export const FORMAT_DATE = 'YYYY-MM-DD';
export const FORMAT_PAYMENT_DATE = 'DD-MM-YYYY';
export const FORMAT_START_DATE = 'YYYY-MM-01';
export const API_URI = '/api/treasury/';
export const STATUS_LABEL_DETAIL = [
    'label-default',
    'label-warning',
    'label-success',
    'label-warning',
    'label-success'
];
export const TEXT_LABEL_DETAIL = [
    '',
    'Pendiente',
    'Pagado',
    'Pendiente',
    'Aprobado'
];
export const TEXT_LABEL_SUMMARY = [
    'Pendiente',
    'Generada',
    'Pagado',
    'Pendiente',
    'Aprobado'
];
export const TEXT_LABEL_FEETICKET = [
    'Pendiente', 
    'Diferencia', 
    'Generada'
];




// WEBPACK FOOTER //
// ./frontEnd/treasury/payment-partners/consts/index.js